import type { PayloadAction } from '@reduxjs/toolkit';
import type { CampaignEditorReducerCreator } from '../types';

const moveBlock = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<{ blockId: string; direction: 'up' | 'down' }>) => {
    if (!state.blocks) return;
    const { blockId, direction } = action.payload;
    const index = state.blocks.findIndex((block) => block.id === blockId);
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    if (index === -1 || targetIndex < 0 || targetIndex >= state.blocks.length) return;
    const next = [...state.blocks];
    [next[index], next[targetIndex]] = [next[targetIndex], next[index]];
    state.blocks = next;
  });

export default moveBlock;
